import React from "react";
import { Construction } from "lucide-react";
import { Flywheel } from "@/components/brand/Flywheel";

export default function PlaceholderModule({ title, description, eyebrow }) {
  return (
    <div className="relative min-h-[calc(100vh-112px)] px-8 py-10 overflow-hidden" data-testid="placeholder-module">
      <div className="absolute -right-32 -bottom-32 pointer-events-none">
        <Flywheel size={420} opacity={0.05} />
      </div>
      <div className="relative max-w-2xl">
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="text-display-md mt-1 text-ink-primary">{title}</h1>
        <p className="mt-3 text-ink-secondary max-w-lg">{description}</p>
        <div className="mt-8 inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-border-subtle bg-raised text-meta text-ink-secondary">
          <Construction size={14} className="text-gold-600" />
          Module ships in the next Phase 1 wave.
        </div>
      </div>
    </div>
  );
}
